export const VAULT_ACCESS_BLOCKED = 'Vault Access Blocked';
export const VAULT_ACCESS_UNBLOCKED = 'Vault Access Unblocked';
export const UNEXPECTED_ERROR_MESSAGE = 'There was an unexpected error executing this. Please contact support.';
